import { Routes, RouterModule, PreloadAllModules, Router } from '@angular/router';
import { Injector, ModuleWithProviders, NgModule } from '@angular/core';


@NgModule({
  imports: [RouterModule.forRoot([], 
    { 
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled' 
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

  constructor() {
  }
  
}